/* Bcustom - ponte tra widget sconti AOV.ai, opzioni prodotto (YMQ / Hulk) e cart drawer del tema.
   1. Blocca l'aggiunta al carrello se un'opzione obbligatoria (es. COLORE) non e' scelta.
   2. Copia nel carrello tutte le opzioni scelte (properties[...]) anche quando aggiunge AOV.
   3. Fa aspettare il redirect di AOV finche' il carrello contiene davvero il prodotto. */
(function () {
  if (window.__bcAovBridge) return;
  window.__bcAovBridge = true;

  var FORM_SEL = 'form[action*="/cart/add"][id^="product-form"]';

  function productForm() {
    return document.querySelector(FORM_SEL);
  }

  function chosenProperties() {
    var props = {};
    /* il tema ha piu' form prodotto (principale + sticky): unisco le opzioni di tutti */
    document.querySelectorAll(FORM_SEL).forEach(function (form) {
      new FormData(form).forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (!m) return;
        if (typeof value !== 'string' || value.trim() === '') return;
        props[m[1]] = value;
      });
    });
    return props;
  }

  function missingRequired() {
    var missing = [];
    document.querySelectorAll('#ymq-box .ymq-options-box').forEach(function (box) {
      var label = box.querySelector('.ymq_lable.required, .required');
      if (!label) return;
      var field = box.querySelector('select, input:not([type=hidden]), textarea');
      if (!field) return;
      var v = (field.value || '').trim();
      var placeholder = field.tagName === 'SELECT' && field.selectedIndex <= 0 && /selez|choose|select/i.test(field.options[0] ? field.options[0].text : '');
      if (!v || placeholder) missing.push({ box: box, field: field, name: label.textContent.replace('*', '').trim() });
    });
    return missing;
  }

  function flagMissing(list) {
    var first = list[0];
    list.forEach(function (m) {
      m.field.style.setProperty('border-color', '#ff005d', 'important');
      m.field.style.setProperty('box-shadow', '0 0 0 3px rgba(255,0,93,.15)', 'important');
      if (!m.box.querySelector('.bc-req-msg')) {
        var msg = document.createElement('div');
        msg.className = 'bc-req-msg';
        msg.textContent = 'Scegli ' + (m.name ? m.name.toLowerCase() : 'questa opzione') + ' per continuare';
        msg.style.cssText = 'color:#ff005d;font-size:12px;font-weight:600;margin-top:6px';
        m.box.appendChild(msg);
      }
      m.field.addEventListener('change', function clear() {
        m.field.style.removeProperty('border-color');
        m.field.style.removeProperty('box-shadow');
        var msg = m.box.querySelector('.bc-req-msg');
        if (msg) msg.remove();
        m.field.removeEventListener('change', clear);
      });
    });
    first.box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { try { first.field.focus({ preventScroll: true }); } catch (e) {} }, 400);
  }

  /* 1. validazione prima di qualsiasi altro script (capture su window) */
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button');
    if (!btn) return;
    var form = btn.closest(FORM_SEL) || (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form')));
    var isAtc = form && (btn.type === 'submit' || btn.name === 'add' || /acquista ora|aggiungi/i.test(btn.textContent));
    if (!isAtc) return;
    var missing = missingRequired();
    if (missing.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      flagMissing(missing);
    }
  }, true);

  /* 2 + 3. fetch verso /cart/add: aggiunge le opzioni e apre il drawer */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = /\/cart\/add(\.js)?/.test(url);
    var fromAov = isAdd && /app=aov/i.test(url);
    if (isAdd && init && typeof init.body === 'string') {
      try {
        var props = chosenProperties();
        if (Object.keys(props).length) {
          var body = JSON.parse(init.body);
          var items = body.items || [body];
          items.forEach(function (it) {
            it.properties = Object.assign({}, props, it.properties || {});
          });
          init = Object.assign({}, init, { body: JSON.stringify(body) });
        }
      } catch (err) {}
    }
    var req = nativeFetch.call(this, input, init);
    if (!fromAov) return req;
    /* AOV porta al carrello appena riceve la risposta: aspetto che il carrello
       mostri davvero il prodotto, cosi' il cliente non vede il carrello vuoto */
    var wanted = [];
    try { wanted = (JSON.parse(init.body).items || []).map(function (it) { return String(it.id); }); } catch (e) {}
    return req.then(function (res) {
      if (!res.ok || !wanted.length) return res;
      return waitForCart(wanted, 8).then(function () { return res; });
    });
  };

  function waitForCart(ids, tries) {
    return nativeFetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = cart.items.map(function (i) { return String(i.variant_id); });
        var ok = ids.every(function (id) { return inCart.indexOf(id) !== -1; });
        if (ok || tries <= 0) return;
        return new Promise(function (r) { setTimeout(r, 250); }).then(function () { return waitForCart(ids, tries - 1); });
      })
      .catch(function () {});
  }
})();
